import cn from 'classnames'
import React from 'react'

import FormFieldHint from './ListingForm/FormFieldHint/FormFieldHint'

interface PasswordInputProps {
  value: string
  required?: boolean
  className?: string
  errorMessage?: string | null
  onChange: (title: string) => void
  onBlur?: () => void
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  value = '',
  className = '',
  errorMessage = null,
  required = false,
  onChange,
  onBlur = () => {},
}) => {
  return (
    <div className="flex flex-col relative">
      <input
        type="password"
        autoComplete="off"
        className={cn('pl-[0.25rem] w-full text-password', errorMessage ? 'rectangle-err' : 'rectangle', className)}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
      />
      {errorMessage && <FormFieldHint className="absolute top-[45px]">{errorMessage}</FormFieldHint>}
    </div>
  )
}
